import axios from 'axios'

const API_HOST = process.env.VUE_APP_API_HOST || '/'

export async function getRetailData(zipCode) {
	try {
		const response = await axios.get(
			`${API_HOST}media/getData.php?service=retail&brandName=Raypak&radius=50&sortOrder=asc&installs=IGNORE&storeType=Retail&top=100&skip=0&draw=0&postalCode=${zipCode}`
		)
		return response.data
	} catch (error) {
		console.log(error)
		return []
	}
}

export async function getInHomeData(zipCode) {
	try {
		const response = await axios.get(
			`${API_HOST}media/getData.php?service=retail&brandName=Raypak&radius=50&sortOrder=asc&installs=IGNORE&storeType=InHomeServiceProvider&top=100&skip=0&draw=0&postalCode=${zipCode}`
		)
		return response.data
	} catch (error) {
		console.log(error)
		return []
	}
}
